import React, { FunctionComponent, useState } from "react";
import styles from "./HeroBannerCurved.module.scss";
import HeroBannerCurvedContent from "./HeroBannerCurvedContent.model";

import { useInView } from "react-intersection-observer";
import Anchor from "components/Anchor/Anchor";
import combineClasses from "helpers/combine-classes";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import formatDynamicTextColor from "blocks/helpers/formatDynamicTextColor";
import getProcessedRichtext from "blocks/helpers/getProcessedRichtext";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";
import isBrowserContext from "helpers/isBrowserContext";
import formatDynamicTextBreak from "blocks/helpers/formatDynamicTextBreak";
import Badge from "../TeaserBanner/components/BadgeSVG/BadgeSVG";
import BlockButton from "components/BlockButton/BlockButton";

const HeroBannerCurved: FunctionComponent<HeroBannerCurvedContent> = (props) => {
    const processedHeadline = getProcessedRichtext(formatDynamicTextBreak(formatDynamicTextColor(props.content.headline)));
    const wrapperStyles = getWrapperStyles(props.settings);

    const { ref, inView } = useInView({ triggerOnce: true });
    const isBrowserClass = isBrowserContext() ? styles.isBrowser : undefined;
    const inViewClass = inView ? styles.isInView : undefined;

    const bgColor = props.settings?.backgroundColor?.color || "#d8e8c5";
    const badgeBgColor = props.settings?.badgeBackgroundColor?.color || "#d8e8c5";
    const badgeTextColor = props.settings?.badgeTextColor?.color || "#000000";
    const maskColor = `${props.settings?.maskColor?.color || "#FFFFFF"}`;
    return (
        <div
            className={combineClasses([styles.wrapper, ...wrapperStyles])}
            style={{ backgroundColor: maskColor }}
        >
            {/* Clip Path Definition for Firefox - Shape() not supported https://caniuse.com/?search=shape*/}
            <svg
                width="0"
                height="0"
                style={{ position: "absolute", pointerEvents: "none" }}
            >
                <defs>
                    <clipPath
                        id="clip-shape"
                        clipPathUnits="objectBoundingBox"
                    >
                        <path
                            d="
                  M 1 0.4796
                  C 1 0.4796 0.9725 0.4893 0.9604 0.4935
                  C 0.9519 0.4955 0.9294 0.5033 0.91 0.5108
                  C 0.9038 0.5127 0.89 0.518 0.8792 0.5226
                  C 0.8722 0.5253 0.857 0.5318 0.8452 0.537
                  C 0.8375 0.5399 0.821 0.5475 0.8082 0.5541
                  C 0.8 0.5576 0.7823 0.5661 0.7689 0.5732
                  C 0.7515 0.5824 0.7135 0.6026 0.6842 0.6182
                  C 0.665 0.6286 0.6244 0.6507 0.5935 0.6675
                  C 0.5732 0.6789 0.5314 0.7042 0.5001 0.7239
                  C 0.4826 0.7352 0.4473 0.7587 0.4212 0.7764
                  C 0.3975 0.7927 0.3509 0.8245 0.3172 0.8476
                  C 0.2976 0.8617 0.2598 0.8868 0.2328 0.9036
                  C 0.2143 0.9156 0.1802 0.9359 0.1564 0.9489
                  C 0.1398 0.9584 0.1106 0.9724 0.0911 0.9801
                  C 0.0771 0.9859 0.0543 0.9931 0.04 0.9962
                  C 0.0294 0.9986 0.0146 1.0002 0.007 1
                  L 0 1
                  L 0 0
                  L 1 0
                  Z"
                        />
                    </clipPath>
                </defs>
            </svg>

            <div
                className={combineClasses([styles.inner])}
                style={{ backgroundColor: `${bgColor}` }}
            >
                <div
                    className={combineClasses([styles.content, isBrowserClass, inViewClass])}
                    ref={ref}
                >
                    <div className={styles.text_content}>
                        {/* Headline */}
                        {props.content.headline ? (
                            <DynamicHeading
                                className={styles.headline}
                                headlineSize={props.content.headlineSize}
                                headlineWeight={props.content.headlineWeight}
                                innerHtml={processedHeadline}
                            ></DynamicHeading>
                        ) : null}

                        {/* Buttons */}
                        {props.content.buttons && props.content.buttons.length > 0 ? (
                            <div className={styles.buttons}>
                                {props.content.buttons.map((button) => {
                                    return (
                                        <BlockButton
                                            key={button.contentUdi}
                                            label={button?.label}
                                            link={button?.link}
                                            target={button?.target}
                                            backgroundColor={button?.backgroundColor}
                                            textColor={button?.textColor}
                                            borderColor={button?.borderColor}
                                            backgroundHoverColor={button?.backgroundHoverColor}
                                            hoverTextColor={button?.hoverTextColor}
                                        />
                                    );
                                })}
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
            {props.content.badgeToggle && props.content.badgeText ? (
                <div className={styles.badge_wrapper}>
                    <Badge
                        text={props.content.badgeText}
                        backgroundColor={badgeBgColor}
                        color={badgeTextColor}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default HeroBannerCurved;
